import { Injectable, Inject } from '@angular/core';
import { Http, Response, Headers } from '@angular/http';
import { Router } from "@angular/router";
import { Payment } from '../../models/payment/payment-model';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { CookieService } from 'ngx-cookie-service';


@Injectable()
export class PaymentService {
  private serviceName = 'api/payment';
  constructor(private http: Http, private readonly router: Router, private cookieService: CookieService) { }

  //insertPaymentMethod(paymentMethodmodel: Payment): void {
  //  this.http
  //    .post(`${this.serviceName}`, paymentMethodmodel, {})
  //    .subscribe(result => {
  //      this.router.navigate(["/payment"]);
  //    });
  //}
  InsertPaymentMethod(payment: Payment) {
    return this.http
      .post(`${this.serviceName}`, payment, {
        headers: new Headers({
          "Token": this.cookieService.get('Login')
        })
      })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  AddPaymentLogo(formData: any, userId: number): void {
    this.http
      .post(`${this.serviceName}/SavePaymentLogo?userId=` + userId, formData, {
        headers: new Headers({
          "Token": this.cookieService.get('Login')
        })
      })
      .subscribe(result => {
        setTimeout(() => {
          this.router.navigate(["/payment-list"]);
          }, 1000);
       
      });
  }
  //updatePaymentMethod(paymentMethodmodel: Payment): void {
  //  //Todo
  //  this.http
  //    .put(`${this.serviceName}`, paymentMethodmodel, {})
  //    .subscribe(result => {
  //      this.router.navigate(["/payment"]);
  //    });
  //}
  updatePaymentMethod(paymentMethodmodel: Payment) {
    return this.http
      .post(`${this.serviceName}/UpdatePayment?value=`, paymentMethodmodel, {
        headers: new Headers({
          "Token": this.cookieService.get('Login')
        })
      })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  //AddPaymentLogo(formData: any): void {
  //  this.http
  //    .post(`${this.serviceName}/SavePaymentLogo`, formData, {})
  //    .subscribe(result => {
  //      if (result) {
  //        this.toastr.success('payment method  save successfully.', 'Success');
  //        setTimeout(() => {
  //          this.router.navigate(["/payment-list"]);
  //        }, 2000);
  //      }
  //      else {
  //        this.toastr.error('Error occurred. Please try again', 'Success');
  //      }
  //    });
  //}
  deletePaymentMethod(id: string) {
    return this.http.get(`${this.serviceName}/Delete?id=` + id, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  getPaymentMethods() {
    return this.http.get(`${this.serviceName}`, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  getActivePaymentMethods() {
    return this.http.get(`${this.serviceName}/GetActivePaymentMethods`, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  getPaymentMethodById(id: string) {
    return this.http.get(`${this.serviceName}/` + id, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  PaymentMethodById(id: number) {
    return this.http.get(`${this.serviceName}/GetPaymentMethod?id=` + id, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  errorHandler(error: Response) {
    
    return Observable.throw(error);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/payment/payment.service.ts